/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_dashboard_kyc_go_to_kyc = /** @type {(inputs: {}) => string} */ () => {
	return `Ir a verificación de identidad`
};

const en_dashboard_kyc_go_to_kyc = /** @type {(inputs: {}) => string} */ () => {
	return `Go to identity verification`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const dashboard_kyc_go_to_kyc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.dashboard_kyc_go_to_kyc(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("dashboard_kyc_go_to_kyc", locale)
	if (locale === "es") return es_dashboard_kyc_go_to_kyc(inputs)
	return en_dashboard_kyc_go_to_kyc(inputs)
};
export { dashboard_kyc_go_to_kyc as "dashboard.kyc.go_to_kyc" }